export const RESOURCE_TO_STORE = {
  patient: "PATIENTS",
  consultation: "CONSULTATIONS",
  medicine: "MEDICINE",
  appointment: "APPOINTMENTS",
  justification: "JUSTIFICATIONS",
  orientationLetter: "LETTRES_ORIENTATION",
  medicalCertificate: "CERTIFICATS",
  workStopping: "ARRETS_TRAVAIL",
  bilan: "BILANS",
  prescription: "PRESCRIPTIONS",
  qsp: "QSP",
  genre: "GENRES",
  allTests: "TESTS",
  prestation: "PRESTATIONS",
  payment: "PAYMENTS",
  waitingList: "WAITING_LIST",
  reminder: "REMINDERS",
  user: "USERS",
  expenses: "EXPENSES",
  doctorOffice: "PROFILE",
}
